__turbopack_context__.v({
  "body": "BoardSectionItemHighlight-module-scss-module__tQDjaG__body",
  "header": "BoardSectionItemHighlight-module-scss-module__tQDjaG__header",
  "title": "BoardSectionItemHighlight-module-scss-module__tQDjaG__title",
  "wrapper": "BoardSectionItemHighlight-module-scss-module__tQDjaG__wrapper",
});
